module.exports = __webpack_public_path__ + "img/catagory4.b75e5e84.png";